import {
  Form,
  FormField,
  IFormField,
  RequiredValidator,
  EmailValidator,
} from '@thinknimble/tn-forms'

export type InviteMemberFormInputs = {
  email: IFormField<string>
  role: IFormField<string>
}

export class InviteMemberForm extends Form<InviteMemberFormInputs> {
  static email = FormField.create({
    label: 'Email',
    placeholder: 'member@example.com',
    type: 'email',
    value: '',
    validators: [
      new RequiredValidator({ message: 'Email is required' }),
      new EmailValidator({ message: 'Please enter a valid email address' }),
    ],
  })

  static role = FormField.create({
    label: 'Role',
    placeholder: 'Select a role',
    type: 'text',
    value: '',
    validators: [new RequiredValidator({ message: 'Please select a role' })],
  })
}

export type TInviteMemberForm = InviteMemberForm & InviteMemberFormInputs
